<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <div
          class="d-flex justify-content-between align-items-md-center align-items-start flex-md-row flex-column mb-2"
        >
          <piaf-breadcrumb :heading="$t('menu.list')" />

          <router-link to="/admin/districts/create" class="btn btn-primary top-right-button">
            {{ $t('buttons.addNew') }}
          </router-link>
        </div>

        <div class="separator mb-5" />
      </b-colxx>
    </b-row>

    <template v-if="isLoading">
      <div class="loading"></div>
    </template>

    <template v-else>
      <data-list-item :districts="districts" @update="fetchDistricts" />
    </template>
  </div>
</template>

<script>
import DataListItem from '@/components/Pages/Districts/DataList'

export default {
  components: { DataListItem },
  data() {
    return {
      page: this.$route.query.page || 1,
      apiBase: '/api/dashboard/district'
    }
  },
  computed: {
    apiUrl() {
      return `${this.apiBase}?page=${this.page}`
    },
    districts() {
      return this.$store.getters['districts/districts']
    },
    isLoading() {
      return this.$store.getters['districts/isLoading']
    }
  },
  mounted() {
    this.fetchDistricts()
  },
  methods: {
    linkGen(pageNum) {
      return { query: { page: pageNum } }
    },
    fetchDistricts() {
      this.$store.dispatch('districts/fetchDistricts', { vm: this })
    }
  },
  watch: {
    apiUrl() {
      this.fetchDistricts()
    }
  }
}
</script>
